import ProductTextil from './ProductTextil';

export default ProductTextil;
